// routes/index.tsx
import { RouteObject } from 'react-router-dom';
import AuthenticatedRoute from '../contexts/authenticatedRoute';
import AdminPage from '../pages/AdminPage';
import Home from '../pages/Home';
import ManageAIsPage from '../pages/ManageAIsPage';
import Login from '../components/login';

// const currentUser = JSON.parse(localStorage.getItem('account_web') || 'null');

export const routes: RouteObject[] = [
    {
        path: '/login',
        element: <Login />,
    },
    {
        element: <AuthenticatedRoute />,
        children: [
            {
                path: '/',
                element: (
                    <Home
                    // provider="minimax"
                    // setProvider={() => {}}
                    // reloadKey={0}
                    // onAccountChange={() => {}}
                    />
                ),
            },
            {
                path: '/admin',
                element: (
                    <AdminPage
                    // user={currentUser}
                    />
                ),
            },
            {
                path: '/manage-ais',
                element: <ManageAIsPage />,
            },
        ],
    },
];
